import { YuukyuuKanriApi } from "@/api/YuukyuuKanriApi";
import { GetDaichouInfoRes, GetYuukyuuListRes, GetShinseiReq, ListSearchItem, KanriDaichouListData, YuukyuuShinseiData, DaichouInfoForNewForm, GetCreateNewDaichouRes } from "@/types/YuukyuuKanri";
import { DialogService } from "@/service/DialogService";
import Message from '@/const/Message';

export class YuukyuuKanriService {

  /**
   * 指定された期間の承認された有給休暇申請一覧を取得します
   * @param userId
   * @param start
   * @param end
   * @returns
   */
  public async getYuukyuuShinseiList(
    userId: number,
    start: string | null,
    end: string | null,
    konnenFuyoDays: number | null,
    kurikoshiDays: number | null,
    tokubetsuKyuuka: number | null
  ): Promise<GetYuukyuuListRes> {
    const api = new YuukyuuKanriApi();
    const req: GetShinseiReq = {
      userId: userId,
      start: start,
      end: end,
      konnenFuyoDays: konnenFuyoDays,
      kurikoshiDays: kurikoshiDays,
      tokubetsuKyuuka: tokubetsuKyuuka,
    };
    let res = null;
    try {
      res = await api.getShinseiList(req);
    } catch (e: any) {
      return e;
    }
    if (!res) {
      throw new Error('');
    }
    return res;
  }

  /**
   * 特定ユーザの有給休暇管理台帳情報を取得します
   * @param userId
   * @returns
   */
  public async getKanriDaichouInfo(userId: number): Promise<GetDaichouInfoRes> {
    const api = new YuukyuuKanriApi();
    let res = null;
    try {
      res = await api.getInfo(userId);
    } catch (e: any) {
      DialogService.error({
        title: Message.ERROR_GET_DAKOKU.DIALOG_TITLE,
        text: Message.ERROR_GET_DAKOKU.TEXT
      })
    }
    if (!res) {
      throw new Error('');
    }
    return res
  }

  /**
   * 検索条件に一致する有給休暇管理台帳情報一覧を取得します
   * @param params
   * @returns
   */
  public async getKanriDaichouInfoList(params: ListSearchItem): Promise<KanriDaichouListData[]> {
    const api = new YuukyuuKanriApi();
    let res = null;
    try {
      res = await api.getList(params);
    } catch (e: any) {
      DialogService.error({
        title: Message.ERROR_GET_DAKOKU.DIALOG_TITLE,
        text: Message.ERROR_GET_DAKOKU.TEXT
      })
    }
    if (!res) {
      return [];
    }
    return res.list;
  }

  /**
   * 今年度付与日数の更新
   * @returns
   */
  public async updateFuyo(userId: number, fuyoDays: number, tokubetsuKyuukaDays: number, fuyoDate: string): Promise<Boolean> {
    const api = new YuukyuuKanriApi();
    let res = null;
    const req = {
      userId: userId,
      fuyoDays: fuyoDays,
      tokubetsuKyuukaDays: tokubetsuKyuukaDays,
      fuyoDate: fuyoDate,
    }
    try {
      res = await api.fuyoUpdate(req);
      if (!res) {
        throw new Error('')
      }
    } catch (e: any) {
      throw e;
    }
    return true
  }

  /**
   * 有給取り消し
   * @returns
   */
  public async deleteYuukyuu(yuukyuu: YuukyuuShinseiData): Promise<Boolean> {
    const api = new YuukyuuKanriApi();
    let res = null;
    const req = {
      userId: yuukyuu.user_id,
      syutokuId: yuukyuu.yuukyuu_syutoku_id,
      yuukyuuDate: yuukyuu.yuukyuu_syutoku_date,
      yuukyuuTani: yuukyuu.yuukyuu_tani_type,
      syuugyouBasyoId: yuukyuu.mst_syuugyou_basyo_id,
      koyouKeiyakuId: yuukyuu.koyou_keiyaku_id,
      yuukyuuTimes: yuukyuu.yuukyuu_times,
    }
    try {
      res = await api.yuukyuuDelete(req);
      if (!res) {
        throw new Error('')
      }
    } catch (e: any) {
      return false
    }
    return true;
  }

  // 個人別有給管理台帳の付与日選択オプション取得
  public async getFuyobiOptions(userId: number) {
    const api = new YuukyuuKanriApi();
    try {
      return await api.getFuyobiOptions(userId);
    } catch (e) {
      throw e
    }
  }

  // 指定した付与日の台帳情報を取得
  public async getPastDaichouInfo(userId: number, start: string, end: string) {
    const api = new YuukyuuKanriApi();
    try {
      return await api.getPastDaichouInfo(userId, start, end);
    } catch (e) {
      throw e
    }
  }

  // 新規に有休付与データを登録します
  public async createNewFuyoData(form: DaichouInfoForNewForm): Promise<GetCreateNewDaichouRes>{
    const api = new YuukyuuKanriApi();
    try {
      return await api.createNewFuyoData(form);
    } catch (e) {
      throw e
    }

  }
}
